import { FC } from 'react';
import { createPortal } from 'react-dom';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import styles from './TripRightPanelFilters.module.scss';
import CustomSwitch from '../../../../../common/CustomSwitch';
import { CalendarIcon, GlobalIcon } from '../../../../../components/Icons';

export interface TripRightPanelFiltersInterface {
  displayFormat: 'map' | 'calendar';
}

interface TripRightPanelFiltersProps {
  filters: TripRightPanelFiltersInterface;
  onFiltersChange: (filters: TripRightPanelFiltersInterface) => void;
  onClose: () => void;
}

const TripRightPanelFilters: FC<TripRightPanelFiltersProps> = ({
  filters,
  onFiltersChange,
  onClose,
}) => {
  const toggleDisplayFormat = () => {
    const newFormat = filters.displayFormat === 'map' ? 'calendar' : 'map';
    onFiltersChange({
      ...filters,
      displayFormat: newFormat,
    });
  };

  return createPortal(
    <Box className={styles.tripRightPanelFilters}>
      <Box className={styles.header}>
        <Typography
          variant="h5Bold"
          sx={{ color: '#222B3A' }}
        >
          Filters
        </Typography>
        <IconButton
          onClick={onClose}
          className={styles.closeButton}
          aria-label="Close filters"
          size="small"
        >
          <CloseIcon sx={{ width: 30, height: 30, color: '#5E6A81' }} />
        </IconButton>
      </Box>

      <Box className={styles.content}>
        <Box className={styles.filterSection}>
          <Typography
            variant="h9Bold"
            className={styles.sectionTitle}
          >
            Display format
          </Typography>

          <Box className={styles.filterOptions}>
            <CustomSwitch
              label="Map"
              checked={filters.displayFormat === 'map'}
              onChange={toggleDisplayFormat}
              icon={<GlobalIcon size={24} />}
            />
            <CustomSwitch
              label="Calendar"
              checked={filters.displayFormat === 'calendar'}
              onChange={toggleDisplayFormat}
              icon={<CalendarIcon size={24} />}
            />
          </Box>
        </Box>
      </Box>
    </Box>,
    document.body
  );
};

export default TripRightPanelFilters;
